<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>SalesNet</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <!-- container -->
    <main id="cont" class="product_sees">
      <div class="subCon seesCon inner_box">
        <section id="salesnet">
          <h3 class="con_tit">SalesNet 소개</h3>
          <div class="sstxt">
            <h4>
              패션 및 유통업계를 위한 최적의
              <span><strong>ERP</strong>솔루션</span>
            </h4>
            <p>
              SalesNet은 패션 및 유통 산업에 특화된 통합 ERP 솔루션으로, <br>
              기업의 복잡한 운영 프로세스를 효율적으로 관리하고 비즈니스 성과를 극대화합니다.<br>
               최신 기술과 업계 전문성을 결합하여 설계된 SalesNet을 아래에서 체험해보세요           
            </p>
            <b-button variant="danger" pill @click="onClickRedirect()">
              SalesNet 체험하러가기
            </b-button>
          </div>
          <div class="titBox gb">
              <h5></h5>
              <div class="conBox">
                <ul class="clearfix">
                
                    <v-img
                      src="@/assets/img/product/salesnet/salesnet.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 70%;
                        align-items: center;
                      "
                    />
                    <div class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center">
                      <p>깔끔하고 정갈한 UI를 제공하여 사용하고 싶은 영업관리 제공
                      </p>
                      <p>메인화면에 브랜드 별 추이를 한눈에 파악 할 수 있는 보고서 제공
                      </p>
                      <p>메뉴 간 TAB을 이용하여 이동 및 사용 편의성 제공
                      </p>
                      <p>자주 쓰는 메뉴에 대한 즐겨찾기 기능 제공
                      </p>
                      <p>엑셀 다운/업로드 기능으로 일괄 업로드 및 일괄 다운기능 제공
                      </p>
                    </div>
                </ul>
              </div>
            </div>
          <section class="con">
            <section class="kind clearfix">
              <dl>
                <dt>다양한 환경 지원</dt>
                <dd>
                  <ul>
                    <li>
                      - 시 공간의 제약이 없는 사용자 접근성 제공공
                    </li>
                    <li>- 높은 생산성과 효율성</li>
                    <li>- 필요한 기능과 프로세스를 제안</li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>신속한 분석 및 설계</dt>
                <dd>
                  <ul>
                    <li>
                      - 고객의 요구와 업무 환경을 면밀히 분석
                    </li>
                    <li>- 최신 트렌드를 반영한 풍부한 기능</li>
                    <li>- 고객의 다양한 요구사항 충족</li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>확장성 및 통합성</dt>
                <dd>
                  <ul>
                    <li>
                      - 최적화된 컴포넌트를 활용하여 빠른 구축
                    </li>
                    <li>- 고객의 요구에 유연한 대응 가능</li>
                  </ul>
                </dd>
              </dl>     
              
            </section>

            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10 landing-warpper text-center"
              rounded
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/safenet/safenet_icon2-2.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>통합된 데이터 관리</dt>
                        <dd>- 중앙화된 데이터 플랫폼
                          <br>
                          - 정확한 의사결정 지원
                        </dd>
                        
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/safenet/safenet_icon1-1.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          실시간 정보 제공
                        </dt>
                        <dd>
                          재고 및 주문 상태 추적 <br />
                          판매 성과 모니터링
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <v-img
                        src="@/assets/img/product/safenet/safenet_icon2-4.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 20%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          패션 업계 맞춤형 기능
                        </dt>
                        <dd>
                          자재관리 및 생산관리 최적화<br />
                          옴니채널 통합
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    ><div>
                      <v-img
                        src="@/assets/img/product/rhipe/rhipe_icon1-3.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 12%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>사용자 친화적인 인터페이스</dt>
                        <dd>
                          직관적인 UI로 높은 사용자 만족도 제공<br />
                          맞춤형 워크플로우 설정 가능
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    ><div>
                      <v-img
                        src="@/assets/img/conversion/casestudy/case_icon1.png"
                        alt=""
                        style="
                          margin: 0 auto;
                          max-width: 12%;
                          align-items: center;
                        "
                      />
                      <dl>
                        <dt>
                          고객 중심의 운영 지원
                        </dt>
                        <dd>CRM 통합
                        </dd>
                      </dl>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>

            <div class="titBox gb">
              <h5>FrameWork</h5>
              <div class="conBox">
                <ul class="clearfix">
                  <li style="width:33%;">
                    <v-img
                      src="@/assets/img/product/salesnet/vue.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 33%;
                        align-items: center;
                      "
                    />
              
                  </li>
                  <li style="width:33%;">
                    <v-img
                      src="@/assets/img/product/salesnet/postgres.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 33%;
                        align-items: center;
                      "
                    />
              
                  </li>
                  <li style="width:33%;">
                    <v-img
                      src="@/assets/img/product/salesnet/spring.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 33%;
                        align-items: center;
                      "
                    />
                 
                  </li>
              
                </ul>
              </div>
            </div>
          </section>
        </section>
        <!-- #sysmind -->
      </div>
    </main>
  </div>
</template>
<script>

export default {
  methods: {
  onClickRedirect : function() {   
          window.open("http://www.oncrewsoft.com:48080/#/login", "_blank");    
      }
}
}
</script>
<style lang=""></style>
